import React, { useReducer } from 'react';
import { CronGeneratorContext, cronGeneratorInitialState, TCronGeneratorTab, TFieldName } from './cronGeneratorContext';
import { cronGeneratorReducer } from './cronGeneratorReducer';
import { CronGeneratorActionTypes } from './cronGeneratorActions';

const CronGeneratorState = ({ children }: JSX.ElementChildrenAttribute) => {
	const [state, dispatch] = useReducer(cronGeneratorReducer, cronGeneratorInitialState);

	const changeVisibleForm = (value: TCronGeneratorTab) => {
		dispatch({
			type: CronGeneratorActionTypes.CHANGE_VISIBLE_FORM,
			payload: {
				visibleForm: value,
			},
		});
	};

	const setFieldValue = (fieldName: TFieldName, value: string) => {
		dispatch({
			type: CronGeneratorActionTypes.SET_FIELD_VALUE,
			payload: {
				fieldName,
				value,
			},
		});
	};

	return (
		<CronGeneratorContext.Provider
			value={{
				changeVisibleForm,
				setFieldValue,
				visibleForm: state.visibleForm,
				seconds: state.seconds,
				minutes: state.minutes,
				hours: state.hours,
				dayOfMonth: state.dayOfMonth,
				month: state.month,
				dayOfWeek: state.dayOfWeek,
				year: state.year,
			}}>
			{children}
		</CronGeneratorContext.Provider>
	);
};

export default React.memo(CronGeneratorState);
